var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOffLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3499 15.1595C13.0918 15.9222 11.5999 16.364 10 16.364C6.01269 16.364 2.69547 13.6205 2 10C2.32291 8.31896 3.21101 6.82702 4.46895 5.71098L2.15678 3.5L3.20255 2.5L17.8432 16.4999L16.7975 17.5L14.3499 15.1595ZM5.51539 6.71163C4.53273 7.56754 3.81624 8.70389 3.50935 10C4.18777 12.8651 6.86787 14.9498 10 14.9498C11.1827 14.9498 12.301 14.6525 13.2714 14.1282L11.7716 12.694C11.2586 13.0031 10.6511 13.182 10 13.182C8.16222 13.182 6.6724 11.7573 6.6724 10C6.6724 9.37734 6.85942 8.79645 7.18267 8.30595L5.51539 6.71163ZM10.6756 11.646L8.27867 9.35401C8.19647 9.55412 8.15133 9.77198 8.15133 10C8.15133 10.9763 8.97904 11.7678 10 11.7678C10.2384 11.7678 10.4663 11.7246 10.6756 11.646ZM16.5121 13.2473L15.4541 12.2355C15.9391 11.5745 16.2966 10.8191 16.4906 10C15.8122 7.13481 13.1321 5.05025 10 5.05025C9.37451 5.05025 8.76704 5.13339 8.18995 5.28927L7.02305 4.17344C7.94503 3.82656 8.94924 3.63604 10 3.63604C13.9873 3.63604 17.3045 6.37944 18 10C17.7691 11.2018 17.2494 12.307 16.5121 13.2473ZM9.7949 6.82396C9.8627 6.82002 9.93111 6.81802 10 6.81802C11.8377 6.81802 13.3276 8.24264 13.3276 10C13.3276 10.0658 13.3255 10.1313 13.3214 10.1961L9.7949 6.82396Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOffLine);
export default __webpack_public_path__ + "static/media/eye-off-line.aacfb88aa35367e13a2da1d32549ea10.svg";
export { ForwardRef as ReactComponent };